export default (function (_ref) {
  var request = _ref.request;
  return {
    baiduAiProblem: function baiduAiProblem(params) {
      return request({
        url: "/common/baidu/ai/problem",
        method: 'get',
        params: params,
        timeout: 60000
      });
    },
    baiduAiTextToAudio: function baiduAiTextToAudio(params) {
      return request({
        url: "/voice/textToAudio/short",
        method: 'get',
        params: params,
        timeout: 60000
      });
    }
  };
});